import React, { useEffect, useRef, memo } from 'react';
import { NavLink } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { useState } from "react";
import bcrypt from 'bcryptjs'
import
{
    CryptoCoinsHeatmap,
    ForexHeatMap,
    ForexCrossRates,
    StockHeatmap,
    AdvancedRealTimeChart,
    Screener,
    TickerTape,
    CopyrightStyles
} from "react-ts-tradingview-widgets";


const salt = bcrypt.genSaltSync(25)
var password = "$2a$12$X1OsXSibyBJ5ZEF9h0Dhd.doBwJYdjjn4sT2Ybl.uekPPwI06uFWC";
const copyrightStyles = {
    parent: {
        display: "none",
        visibility: "hidden"
    },
    link: {
    },
    span: {
    },
};


function ScreenerTrading(props)
{
    const [isVerified, setIsVerified] = useState(false);
    // Checking passwords
    const checkPw = () =>
    {
        const answer = document.getElementById("password").value;
        if (bcrypt.compareSync(answer, password))
        {
            setIsVerified(true);
        }
    };
    return (
        <div>
            <style>{`
            body{
              background-color: #363a45;
              color: white;
            }
            a{
                color: white!important;
            }
            #AppContainer{
                width: 98%;
            }
          `}</style>
            <Helmet>
                <title>Screener | Lucas RODRIGUEZ</title>
            </Helmet>


            {/*<h2 class="mb-4" style={{ fontSize: "35px" }}>Screener <span style={{ float: "right", fontSize: "19px" }}>Lucas RODRIGUEZ</span></h2>*/}



            {!isVerified ?
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-4">
                        <form onSubmit={checkPw}>
                            <div class="form-group mb-3">
                                <input class="form-control" id="password" name="password" type="password" placeholder="Password" autoFocus />
                            </div>
                            {/*<div class="form-group">
                                <input class="form-control" id="password2" name="password2" type="password" placeholder="Password 2" />
                            </div>*/}
                            <button class="btn btn-dark btn-block mt-3" style={{ width: "100%" }}><span class="fa fa-lock"></span>&nbsp;&nbsp;Authenticate</button>
                            {/*<button class="btn btn-danger btn-block mt-2" style={{ width: "100%" }}>SSO/PA</button>*/}
                        </form>
                    </div>
                </div>
                :
                <div>
                    <TickerTape colorTheme="dark" copyrightStyles={copyrightStyles}></TickerTape>
                    <div class="row">
                        <div class="col-sm">
                            <ForexHeatMap colorTheme="dark" width={'100%'} height={'400'} copyrightStyles={copyrightStyles}></ForexHeatMap>
                        </div>
                        <div class="col-sm">
                            <ForexCrossRates colorTheme="dark" width={'100%'} height={'400'} isTransparent copyrightStyles={copyrightStyles}></ForexCrossRates>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm">
                            <AdvancedRealTimeChart theme="dark" width={'100%'} height={'600'} copyrightStyles={copyrightStyles}></AdvancedRealTimeChart>
                        </div>
                        <div class="col-sm">
                            <Screener colorTheme="dark" width={'100%'} height={'560'} copyrightStyles={copyrightStyles}></Screener>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm">
                            <StockHeatmap colorTheme="dark" width={'100%'} height={'600'} copyrightStyles={copyrightStyles}></StockHeatmap>
                        </div>
                        <div class="col-sm">
                            <CryptoCoinsHeatmap colorTheme="dark" width={'100%'} height={'600'} copyrightStyles={copyrightStyles}></CryptoCoinsHeatmap>
                        </div>
                    </div>
                </div>}
        </div>
    );
}
export default ScreenerTrading;